import React from 'react';

// Styles
import styles from './PatientInfo.module.css';
import { FaMobileAlt } from 'react-icons/fa';
import { MdPhoneInTalk } from 'react-icons/md';

// Hooks
import { useState } from 'react';
import usePatientStore from '../../../stores/patient-store';

// Components
import PatientImage from '../../UI/PatientImage/PatientImage';
import Modal from '../../UI/Modal/Modal';
import DialogDevicesPatient from '../DialogDevicesPatient/DialogDevicesPatient';
import PatientContactInfo from '../PatientContactInfo/PatientContactInfo';
import PatientAssociatedUsers from '../PatientAssociatedUsers/PatientAssociatedUsers';
import PatientAssistentialStaff from '../PatientAssistentialStaff/PatientAssistentialStaff';
import PatientInfoGrid from '../PatientInfoGrid/PatientInfoGrid';

// Interfaces
import { Case, IScoreCircle } from '../../../interfaces/Patient';

// Language
import { useTranslation } from 'react-i18next';
import { getAgePatient, getFullName } from '../../../services/getPatientAtribute';

interface Props {
    caso: Case;
    closedCase: boolean;
    scoreCV: IScoreCircle;
    readOnly: boolean;
    refreshPatientSilently: () => Promise<void>;
}

// PatientInfo: renders some patient info, their image and some
// contact buttons.
const PatientInfo: React.FC<Props> = ({
    caso,
    closedCase,
    scoreCV,
    readOnly,
    refreshPatientSilently
}) => {
    const { t } = useTranslation();

    const patient = usePatientStore(state => state.patient);

    const [showDevicesDialog, setShowDevicesDialog] = useState<boolean>(false);
    const [showContactDialog, setShowContactDialog] = useState<boolean>(false);

    // const globalModalContext = useContext(GlobalModalContext);

    if (patient === null) return null;

    // const handleClickClose = () => {
    //     globalModalContext.setElement(null);
    // };

    // const handleClickCalendar = () => {
    //     globalModalContext.setElement(<CalendarPatient
    //         handleClickClose={handleClickClose}
    //     />);
    // };


    return (
        <div className={`${styles.generalInfoContainer} ${closedCase ? styles.closedCase : ''}`}>
            {patient && (
                <>
                    {window.config.VERSION_IMAGES && (
                        <div className={styles.imageContainer}>
                            <PatientImage image={patient.image} />
                        </div>
                    )}

                    <div className={styles.generalInfo}>
                        <div className={styles.generalInfoTop}>
                            <h1>{getFullName(patient) + ' (' + getAgePatient(patient) + ')'}</h1>
                        </div>

                        <PatientInfoGrid
                            patient={patient}
                            caso={caso}
                            scoreCV={scoreCV}
                            refreshPatientSilently={refreshPatientSilently}
                        />
                    </div>

                    <div className={styles.patientButtons}>
                        {/* <button onClick={handleClickCalendar}>
                            <img src={calendarSVG} alt='icono calendario' />
                            <p className={styles.patientButtonText}>{t('calendar')}</p>
                        </button> */}
                        <button onClick={() => setShowDevicesDialog(true)}>
                            <FaMobileAlt />
                            <p className={styles.patientButtonText}>{t('devices')}</p>
                        </button>
                        <button onClick={() => setShowContactDialog(true)}>
                            <MdPhoneInTalk />
                            <p className={styles.patientButtonText}>{t('contact')}</p>
                        </button>
                    </div>
                </>
            )}

            <Modal show={showDevicesDialog} setShowModal={setShowDevicesDialog}>
                <DialogDevicesPatient
                    patient_id={patient.id}
                    disabledLoanDevices={readOnly}
                    setShowModal={setShowDevicesDialog}
                />
            </Modal>

            <Modal show={showContactDialog} setShowModal={setShowContactDialog}>
                <div className='dialog'>
                    <div className={styles.dialogContainer}>
                        <PatientContactInfo
                            patient={patient}
                            handleCloseModal={() => setShowContactDialog(false)}
                        />
                        <PatientAssociatedUsers
                            patientID={patient.id}
                            disabledAdding={readOnly}
                        />
                        <PatientAssistentialStaff
                            patientID={patient.id}
                            disabledAdding={readOnly}
                        />
                    </div>
                    <div className={styles.closeButtonContainer}>
                        <button className={`button ${styles.buttonClose}`} onClick={() => setShowContactDialog(false)}>
                            {t('close')}
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default PatientInfo;